import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../pages/Layout";
import Home from "../pages/home/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/category/:slug",
        lazy: () => import("../pages/category/page"),
      },
      {
        path: "/article/:slug",
        lazy: () => import("../pages/article/page"),
      },
      {
        path: "/about",
        lazy: () => import("../pages/about/page"),
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;